import { animate, state, style, transition, trigger } from '@angular/animations';

export const animationDuration = 150;

export const expandTableRow = trigger('expandTableRow', [
    state(
        'collapsed',
        style({
            height: '0px',
            minHeight: '0',
            overflow: 'hidden',
            opacity: '0',
        }),
    ),
    state(
        'expanded',
        style({
            height: '*',
            overflow: 'hidden',
            opacity: '1',
        }),
    ),
    transition('collapsed <=> expanded', [animate(`${animationDuration}ms cubic-bezier(0.4, 0.0, 0.2, 1)`)]),
]);
